export default {
  data: function () {
    var ctx = this.$route.context || {};
    var ingresso = ctx.ingresso || {};
    return {
      ingresso: ingresso,
      codigo: ctx.codigo || ingresso.codigo || '',
      rating: ingresso.nota ? parseInt(ingresso.nota, 10) : 0,
      comentario: ingresso.comentario || ''
    };
  },
  methods: {
    getRatingLabel: function (rating) {
      switch (parseInt(rating, 10)) {
        case 1:
          return '1 estrela • Lead frio';
        case 2:
          return '2 estrelas • Interesse baixo';
        case 3:
          return '3 estrelas • Bom lead';
        case 4:
          return '4 estrelas • Lead quente';
        case 5:
          return '5 estrelas • Muito promissor';
        default:
          return 'Toque nas estrelas para avaliar';
      }
    },
    paintStars: function (rating) {
      for (var i = 1; i <= 5; i++) {
        var star = this.$el.find('#star' + i);
        if (i <= rating) {
          star.css('color', '#ffb400');
        } else {
          star.css('color', '#d9dee8');
        }
      }
      this.$el.find('#rating-label').text(this.getRatingLabel(rating));
    },
    salvarLead: function () {
      var self = this;
      var app = self.$app;
      var comentario = self.$el.find('#comentario').val();
      if (!self.codigo) {
        app.dialog.alert('Código do lead não localizado.');
        return;
      }
      app.preloader.show();
      app.request({
        url: app.methods.request('/leitura'),
        method: 'POST',
        dataType: 'json',
        data: {
          codigo: self.codigo,
          nota: self.rating,
          comentario: comentario
        },
        success: function (res) {
          app.preloader.hide();
          if (res && res.success) {
            app.toast.create({
              text: 'Lead atualizado com sucesso',
              closeTimeout: 2000
            }).open();
          } else {
            app.dialog.alert('Erro ao salvar');
          }
        },
        error: function () {
          app.preloader.hide();
          app.dialog.alert('Erro de comunicação');
        }
      });
    },
    limparCampos: function () {
      this.rating = 0;
      this.comentario = '';
      this.$el.find('#comentario').val('');
      this.paintStars(0);
    },
    abrirWhatsApp: function () {
      var numero = this.ingresso.celular_whats || '';
      if (numero) window.location.href = 'whatsapp://send?phone=' + numero;
    },
    ligar: function () {
      var numero = this.ingresso.celular_whats || this.ingresso.celular || '';
      if (numero) window.location.href = 'tel:' + numero;
    }
  },
  on: {
    pageInit: function () {
      var self = this;
      self.paintStars(self.rating);
      self.$el.find('.star-rating').on('click', function () {
        var nota = parseInt(this.getAttribute('data-value'), 10);
        self.rating = nota;
        self.paintStars(nota);
        self.salvarLead();
      });
      self.$el.find('.bt-salvar').on('click', function (e) {
        e.preventDefault();
        self.salvarLead();
      });
      self.$el.find('.bt-limpar').on('click', function (e) {
        e.preventDefault();
        self.limparCampos();
      });
      self.$el.find('.bt-whatsapp').on('click', function (e) {
        e.preventDefault();
        self.abrirWhatsApp();
      });
      self.$el.find('.bt-ligar').on('click', function (e) {
        e.preventDefault();
        self.ligar();
      });
    }
  },
  id: '3d711fbb2a',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=lead-view><div class="navbar no-hairline"><div class=navbar-bg></div><div class="navbar-inner sliding text-align-center"><div class=left><a class="link back"><i class="fas fa-2x fa-arrow-left white"></i></a></div><div class="title titulo-tela-historico">Sobre o Contato</div><div class=right></div></div></div><!-- Toolbar--><div class="toolbar toolbar-bottom"><div class=toolbar-inner><div class=col-10></div><a href=javascript:; class="col-20 link button button-fill button-rounded btnLerCodigo p-2 active"><i class="fas fa-2x fa-qrcode"></i></a> <a href=/codigo/ class="col-20 link button button-fill button-rounded p-2"><i class="fas fa-2x fa-ticket-alt"></i></a> <a href=/leituras/ class="col-20 link button button-fill button-rounded p-2"><i class="fas fa-2x fa-list"></i></a> <a href=/logout/ class="col-20 link button button-fill button-rounded p-2"><i class="fas fa-2x fa-sign-out-alt"></i></a><div class=col-10></div></div></div><!-- Scrollable page content--><div class=page-content style="background:#f5f6fa; min-height:100vh;"><div class=block style="margin-top:20px; margin-bottom:10px;"><div class=card style="margin:0; border-radius:18px; overflow:hidden; box-shadow:0 8px 24px rgba(0,0,0,.08); border:0;"><div class="card-content card-content-padding" style=background:#fff;><div class="display-flex justify-content-space-between align-items-start"><div style="padding-right:12px; flex:1;"><div style="font-size:22px; line-height:1.2; font-weight:700; color:#25345c; text-transform:uppercase;">';
      r += c(ctx_1.ingresso.nome, ctx_1);
      r += '</div><div style="font-size:15px; color:#6b7280; margin-top:4px;">';
      r += c(ctx_1.ingresso.empresa, ctx_1);
      r += '</div></div></div><div style="margin-top:10px; color:#7a7f8c; font-size:13px;"><i>';
      r += c(ctx_1.ingresso.codigo, ctx_1);
      r += ' - ';
      r += c(ctx_1.ingresso.codigo_externo, ctx_1);
      r += '</i></div><div style="margin-top:18px; border-top:1px solid #edf0f5; padding-top:14px;"><div style="margin-bottom:10px; color:#25345c; font-size:15px;"><i class="fas fa-phone-alt" style="width:20px; color:#ff7f11;"></i> WhatsApp/Telefone: ';
      r += c(ctx_1.ingresso.celular, ctx_1);
      r += '</div><div style="margin-bottom:10px; color:#25345c; font-size:15px;"><i class="fas fa-envelope" style="width:20px; color:#ff7f11;"></i> ';
      r += c(ctx_1.ingresso.email, ctx_1);
      r += '</div><div style="margin-bottom:10px; color:#25345c; font-size:15px;"><i class="fas fa-map-marker-alt" style="width:20px; color:#ff7f11;"></i> Perfil: ';
      r += c(ctx_1.ingresso.perfil, ctx_1);
      r += '</div><div style="margin-bottom:10px; color:#25345c; font-size:15px;"><i class="fas fa-map-marker-alt" style="width:20px; color:#ff7f11;"></i> Data do Evento: ';
      r += c(ctx_1.ingresso.dataEvento, ctx_1);
      r += '</div><div style="color:#7a7f8c; font-size:13px;"><i class="fas fa-clock" style="width:20px; color:#ff7f11;"></i> <i>Lido em ';
      r += c(ctx_1.ingresso.data, ctx_1);
      r += '</i></div></div><div class=row style=margin-top:18px;><div class=col-50><a href=# class="button button-fill bt-whatsapp button-small" style="background:#25D366; border-radius:12px;">WhatsApp</a></div><div class=col-50><a href=# class="button button-outline bt-ligar button-small" style=border-radius:12px;>Ligar</a></div></div></div></div></div><div class=block style=margin-top:8px;><div class=card style="margin:0; border-radius:18px; overflow:hidden; box-shadow:0 8px 24px rgba(0,0,0,.08); border:0;"><div class="card-content card-content-padding" style=background:#fff;><div style="font-size:18px; font-weight:700; color:#25345c; margin-bottom:6px;">Avaliação do Contato</div><div class=text-align-center style=margin-bottom:10px;><span class=star-rating data-value=1 style="display:inline-block; margin:0 4px; cursor:pointer;"><i class="fas fa-star" id=star1 style="font-size:32px; color:#d9dee8;"></i> </span><span class=star-rating data-value=2 style="display:inline-block; margin:0 4px; cursor:pointer;"><i class="fas fa-star" id=star2 style="font-size:32px; color:#d9dee8;"></i> </span><span class=star-rating data-value=3 style="display:inline-block; margin:0 4px; cursor:pointer;"><i class="fas fa-star" id=star3 style="font-size:32px; color:#d9dee8;"></i> </span><span class=star-rating data-value=4 style="display:inline-block; margin:0 4px; cursor:pointer;"><i class="fas fa-star" id=star4 style="font-size:32px; color:#d9dee8;"></i> </span><span class=star-rating data-value=5 style="display:inline-block; margin:0 4px; cursor:pointer;"><i class="fas fa-star" id=star5 style="font-size:32px; color:#d9dee8;"></i></span></div><div class=text-align-center id=rating-label style="font-size:13px; color:#6b7280; margin-bottom:16px;">Toque nas estrelas para avaliar</div><div class="list no-hairlines-md no-margin" style=margin-top:0;><ul><li class="item-content item-input"><div class=item-inner><div class="item-title item-label" style="color: #5c5c5c;">Anotações</div><div class=item-input-wrap><textarea id=comentario placeholder="Ex.: Lead quente, pediu retorno, deseja proposta..." rows=5 style=min-height:120px;>';
      r += c(ctx_1.comentario, ctx_1);
      r += '</textarea></div></div></li></ul></div><div class=row style=margin-top:8px;><div class=col-50><a href=# class="button button-fill bt-salvar button-small" style="background:#ff7f11; border-radius:12px;">Salvar</a></div><div class=col-50><a href=# class="button button-outline bt-limpar button-small" style=border-radius:12px;>Limpar</a></div></div></div></div></div></div></div>';
      return r;
    }(this);
  },
  styleScoped: false
};